
export const fontSizes = [
    "10px","11px","12px","13px","14px", "15px", "16px", "17px","18px","19px", "20px", "21px","22px"
]


export const fontWeights = [ 
    100,200,300,400,500,600,700,800,900,1000
]